module.exports = __webpack_public_path__ + "static/frostbyte1-52a6e576190d35159e49ac938dc2ac47.png";